import React, { FC } from 'react';

import { NotificationsForm } from './NotificationsForm';
import { PasswordForm } from './PasswordForm';
import { UserForm } from './UserForm';

import { Container } from '#root/Components/Container';
import { Flex } from '#root/Components/Flex';
import { useRedirectIfLoggedOut } from '#root/hooks/use-redirect-if-logged-in';
import { css } from '#root/utils/css';

export interface AccountType {
  email: string;
  name: string;
}

export const Account: FC = () => {
  useRedirectIfLoggedOut();

  return (
    <Container withPadding marginTop>
      <Flex gap stackOnMobile>
        <UserForm />
        <PasswordForm withCurrentPassword />
      </Flex>
      <NotificationsForm />
    </Container>
  );
};
